import React from 'react'
import { CLASS_PREFIX } from 'src/constants'
import { textResources } from 'src/lang/de'

import './project_list_error_state.scss'

type Props = {
  onRetry: () => void;
};

const cls = `${CLASS_PREFIX}project-list-wrapper`

const t = textResources.projects

export const ProjectListErrorState: React.FC<Props> = ({ onRetry }) => {
  return (
    <div className={`${cls}__state`} role="alert">
      <div className={`${cls}__state-text`}>
        <div className={`${cls}__state-title`}>{t.overview.loadErrorTitle}</div>
        <div className={`${cls}__state-message`}>
          {t.overview.loadErrorMessage}
        </div>
      </div>
      <div className={`${cls}__state-actions`}>
        <button
          type="button"
          className={`${cls}__state-button`}
          onClick={onRetry}
        >
          {t.overview.retry}
        </button>
      </div>
    </div>
  )
}
